import styled from 'styled-components';

const isDarkTheme = (theme: { colors: { text: string; white: string } }): boolean => (
  theme.colors.text === theme.colors.white
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 100px;
  border: 1px solid ${(props) => props.theme.colors.outline};
  font-size: 13px;
  min-width: fit-content;
  cursor: default;
  color: ${(props) => props.theme.colors.text};

  .label {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    height: 100%;
    gap: 4px;
    background-color: ${(props) => (
    isDarkTheme(props.theme) ? props.theme.colors.outline : '#e4e6e8'
  )};
    color: ${(props) => (
    isDarkTheme(props.theme) ? props.theme.colors.text : props.theme.colors.black
  )};
    border-radius: 100px 0 0 100px;
  }

  .trigger {
    padding: 4px 8px;
    color: ${(props) => props.theme.colors.text};
  }
`;

export default { Wrapper };
